(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aera-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
 document.addEventListener('click',function(ev){
   var trigger=ev.target.closest('[data-aera-topic]');
   if(!trigger)return;
   var page=trigger.closest('[data-aera-contact-section]');
   if(!page)return;
   var field=page.querySelector('[data-aera-inquiry]');
   if(!field)return;
   var choice=trigger.getAttribute('data-aera-topic');
   for(var index=0;index<field.options.length;index++){
     if(field.options[index].value===choice){field.selectedIndex=index;break}
   }
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aera-starter-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aera-quickshop').forEach(section=>{
 section.querySelectorAll('[data-aera-category]').forEach(button=>{
  button.addEventListener('click',()=>{
   const category=button.dataset.aeraCategory;
   section.querySelectorAll('[data-aera-category]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
   section.querySelectorAll('[data-aera-kind]').forEach(card=>{card.hidden=category!=='all'&&card.dataset.aeraKind!==category;});
  });
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aera-tester-voices"] && !Shopify.designMode) return;
  try {
    
(function(){
 function update(root){
   var track=root.querySelector('[data-ac-voices-track]');
   if(!track)return;
   var slides=Array.from(track.querySelectorAll('.ac-voices__card'));
   if(!slides.length)return;
   var slideWidth=slides[0].getBoundingClientRect().width;
   var gap=parseFloat(window.getComputedStyle(track).columnGap)||0;
   var current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/(slideWidth+gap))));
   var counter=root.querySelector('[data-ac-voices-current]');
   if(counter)counter.textContent=String(current+1).padStart(2,'0');
   var prev=root.querySelector('[data-ac-voices-direction="-1"]');
   var next=root.querySelector('[data-ac-voices-direction="1"]');
   if(prev)prev.disabled=track.scrollLeft<=2;
   if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
 }
 document.addEventListener('click',function(event){
   var button=event.target.closest('[data-ac-voices-direction]');
   if(!button)return;
   var root=button.closest('.ac-tester-voices');
   if(!root)return;
   var track=root.querySelector('[data-ac-voices-track]');
   var slide=track&&track.querySelector('.ac-voices__card');
   if(!slide)return;
   var gap=parseFloat(window.getComputedStyle(track).columnGap)||0;
   var step=slide.getBoundingClientRect().width+gap;
   var direction=Number(button.getAttribute('data-ac-voices-direction'));
   track.scrollBy({left:step*direction,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 });
 document.addEventListener('scroll',function(event){
   var target=event.target;
   if(!target?.matches?.('[data-ac-voices-track]'))return;
   var root=target.closest('.ac-tester-voices');
   if(root)update(root);
 },true);
 document.addEventListener('shopify:section:load',function(event){
   var root=event.target?.querySelector?.('.ac-tester-voices');
   if(root)update(root);
 });
 window.addEventListener('resize',function(){
   document.querySelectorAll('.ac-tester-voices').forEach(update);
 });
 document.querySelectorAll('.ac-tester-voices').forEach(update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-ampoule-carousel"] && !Shopify.designMode) return;
  try {
    
if (!window.aeraAmpouleCarouselReady) {
window.aeraAmpouleCarouselReady = true;
document.addEventListener('click',function(event) {
  var button=event.target.closest('[data-ampoule-arrow]');
  if(!button)return;
  var root=button.closest('.at-ampoule');
  var track=root&&root.querySelector('[data-ampoule-track]');
  if(!track)return;
  var card=track.querySelector('.at-ampoule__card');
  if(!card)return;
  var direction=Number(button.getAttribute('data-ampoule-arrow'))||1;
  var width=card.getBoundingClientRect().width;
  var gap=parseFloat(window.getComputedStyle(track).gap)||0;
  track.scrollBy({left:direction*(width+gap),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});
document.addEventListener('scroll',function(event){
  var track=event.target;
  if(!track || !track.matches || !track.matches('[data-ampoule-track]'))return;
  var root=track.closest('.at-ampoule');
  if(!root)return;
  var width=track.querySelector('.at-ampoule__card')?.getBoundingClientRect().width||1;
  var gap=parseFloat(window.getComputedStyle(track).gap)||0;
  var index=Math.max(1,Math.min(track.querySelectorAll('.at-ampoule__card').length,Math.round(track.scrollLeft/(width+gap))+1));
  var counter=root.querySelector('[data-ampoule-current]');
  if(counter)counter.textContent=String(index).padStart(2,'0');
},true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ac-masthead details[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

/* Keep the custom AERA CELL bag count aligned with Shopify's AJAX cart state. */
(function(){
  const selector='.ac-masthead__bag';
  let busy=false;
  async function refreshAeraBag(event){
    if(event?.promise){try{await event.promise;}catch(error){return;}}
    const bag=document.querySelector(selector);
    if(!bag || busy) return;
    busy=true;
    try{
      const root=window.Shopify?.routes?.root || '/';
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'});
      if(!response.ok) return;
      const cartData=await response.json();
      const count=Number(cartData.item_count);
      if(!Number.isSafeInteger(count) || count<0) return;
      const countElement=bag.querySelector('.ac-masthead__bag-count');
      if(countElement) countElement.textContent='('+count+')';
      bag.setAttribute('aria-label','View shopping bag, '+count+' '+(count===1?'item':'items'));
    } catch(error){
      /* The bag remains a working Shopify cart link when the network is unavailable. */
    } finally{
      busy=false;
    }
  }
  import('@shopify/events').then(({StandardEvents})=>{
    document.addEventListener(StandardEvents.cartLinesUpdate,refreshAeraBag);
    document.addEventListener(StandardEvents.cartDiscountUpdate,refreshAeraBag);
  });
  document.addEventListener('cart:refresh',refreshAeraBag);
  document.addEventListener('cart:updated',refreshAeraBag);
  window.addEventListener('pageshow',refreshAeraBag);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshAeraBag();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
